import React, { useEffect, useState } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import CustomizedTripsDtlbannersec from "../Components/CustomizedTripsDtlbannersec";
import CustomizedTripsDtlcoversdside from "../Components/CustomizedTripsDtlcoversdside";
import CustomizedTripsDtlcoversdmenu from "../Components/CustomizedTripsDtlcoversdmenu";
import CustomizedTripsDtlcoverinclall from "../Components/CustomizedTripsDtlcoverinclall";
import CustomizedTripsDtlItinerary from "../Components/CustomizedTripsDtlItinerary";
import CustomizedTripsDtlsmillerlist from "../Components/CustomizedTripsDtlsmillerlist";

const SwissTripDetails = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const sections = [
    "overview",
    "itinerary",
    "included",
    "excluded",
    "highlights",
    "faqs",
  ];

  const handleScroll = () => {
    const scrollPos = window.scrollY + 120;
    sections.forEach((id) => {
      const el = document.getElementById(id);
      if (el) {
        const top = el.offsetTop;
        const height = el.offsetHeight;
        if (scrollPos >= top && scrollPos < top + height) {
          setActiveTab(id);
        }
      }
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      window.scrollTo({ top: el.offsetTop - 90, behavior: "smooth" });
    }
  };

  const aboutTrip = {
    title:
      "Create unforgettable family memories exploring the breathtaking Swiss Alps, charming villages, and world-famous attractions. Perfect for families seeking adventure and culture.",
  };

  const destinations = [
    { name: "Zurich", icon: "lucide lucide-map-pin", color: "text-primary" },
    { name: "Lucerne", icon: "lucide lucide-map-pin", color: "text-primary" },
    { name: "Interlaken", icon: "lucide lucide-map-pin", color: "text-primary" },
    { name: "Jungfraujoch", icon: "lucide lucide-map-pin", color: "text-primary" },
    { name: "Bern", icon: "lucide lucide-map-pin", color: "text-primary" },
  ];

  const itineraryDays = [
    {
      day: "1",
      title: "Arrive in Zurich",
      description: "Meet and greet at airport. Transfer to hotel and city orientation walk.",
    },
    {
      day: "2",
      title: "Zurich City Tour",
      description: "Explore Old Town, Lake Zurich, and visit the famous Swiss Chocolate Factory.",
    },
    {
      day: "3",
      title: "Journey to Lucerne",
      description: "Scenic train ride to Lucerne. Visit Chapel Bridge and take a lake cruise.",
    },
    {
      day: "4",
      title: "Mount Pilatus Excursion",
      description: "Cable car ride to Mount Pilatus summit. Enjoy panoramic views and family activities.",
    },
    {
      day: "5",
      title: "Interlaken Adventure",
      description: "Travel to Interlaken. Explore adventure park and enjoy Swiss fondue dinner.",
    },
    {
      day: "6",
      title: "Jungfraujoch - Top of Europe",
      description: "Cogwheel train to Europe's highest railway station. Ice Palace and snow activities.",
    },
    {
      day: "7",
      title: "Grindelwald & Glaciers",
      description: "Visit stunning glaciers and take the First Cliff Walk for amazing views.",
    },
    {
      day: "8",
      title: "Bern & Rhine Falls",
      description: "Explore Swiss capital Bern and visit Europe's largest waterfall.",
    },
    {
      day: "9",
      title: "Return to Zurich",
      description: "Free time for shopping and last-minute exploration. Farewell dinner.",
    },
    {
      day: "10",
      title: "Departure",
      description: "Hotel checkout and airport transfer for your flight home.",
    },
  ];




  const notIncludedItems = [
    { icon: "lucide lucide-x", text: "Transportation to/from Zurich" },
    { icon: "lucide lucide-x", text: "Travel insurance (highly recommended)" },
    { icon: "lucide lucide-x", text: "Personal expenses like laundry, tips, and shopping" },
    { icon: "lucide lucide-x", text: "Any meals not mentioned in the itinerary" },
    { icon: "lucide lucide-x", text: "Entry fees to monuments and attractions not specified" },
    { icon: "lucide lucide-x", text: "Visa fees and processing charges" },
  ];

  const highlights = [
    "Swiss Alps exploration",
    "Chocolate factory tour",
    "Lake cruises",
    "Mountain railways",
  ];


  return (
    <>
      <Header />
      <main className="min-h-screen bg-white pb-0 md:pb-16">
        {/* HEADER IMAGE & TOP BAR */}

      
       <CustomizedTripsDtlbannersec />

        {/* Sticky Tabs */}
        <div className="sticky top-[79px] z-20 bg-white border-b border-slate-200 shadow-sm">
          <div className="container mx-auto px-4">
            <div className="flex items-center justify-start gap-1 overflow-x-auto scrollbar-hide">
              {sections.map((section) => (
                <button
                  key={section}
                  className={`px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                    activeTab === section
                      ? "border-primary text-primary"
                      : "border-transparent text-slate-600 hover:text-slate-900"
                  }`}
                  onClick={() => scrollToSection(section)}
                >
                  {section.charAt(0).toUpperCase() + section.slice(1)}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Content Sections */}
        <div className="container mx-auto px-4 pb-24 md:pb-0 md:px-4">
          <div className="mt-5 md:mt-10 md:grid md:grid-cols-3 md:gap-8 lg:gap-12">
            {/* Left Panel */}
            <div className="w-full md:col-span-2 space-y-6 md:space-y-8">
              {/* Overview */}

              <CustomizedTripsDtlcoversdmenu />

              <CustomizedTripsDtlItinerary />

              <CustomizedTripsDtlcoverinclall />

              {/* Why Connect with Connecting Traveller */}
              <section className="mt-12 md:mt-16 -mx-4 md:-mx-6 lg:-mx-8 px-4 md:px-6 lg:px-8 py-8 md:py-12 bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 border-y border-teal-100">
                <div className="max-w-6xl mx-auto">
                  <div className="text-center mb-8 md:mb-10">
                    <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent mb-3">
                      Why Choose Connecting Traveller?
                    </h2>
                    <p className="text-sm md:text-base text-slate-600 max-w-2xl mx-auto">
                      Your trusted partner in creating unforgettable travel experiences
                    </p>
                  </div>
                  <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
  <div className="bg-white rounded-xl p-4 md:p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-teal-100">
    <div className="h-12 w-12 md:h-14 md:w-14 rounded-full bg-gradient-to-br from-teal-500 to-teal-600 flex items-center justify-center mb-4">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-users h-6 w-6 md:h-7 md:w-7 text-white"
      >
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx={9} cy={7} r={4} />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    </div>
    <h3 className="font-bold text-slate-900 text-base md:text-lg mb-2">
      Expert Travel Planners
    </h3>
    <p className="text-sm text-slate-600 leading-relaxed">
      Experienced team crafting personalized itineraries tailored to your dreams
    </p>
  </div>
  <div className="bg-white rounded-xl p-4 md:p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-teal-100">
    <div className="h-12 w-12 md:h-14 md:w-14 rounded-full bg-gradient-to-br from-teal-500 to-teal-600 flex items-center justify-center mb-4">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-dollar-sign h-6 w-6 md:h-7 md:w-7 text-white"
      >
        <line x1={12} x2={12} y1={2} y2={22} />
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    </div>
    <h3 className="font-bold text-slate-900 text-base md:text-lg mb-2">
      Best Price Guarantee
    </h3>
    <p className="text-sm text-slate-600 leading-relaxed">
      Competitive pricing with transparent costs and absolutely no hidden
      charges
    </p>
  </div>
  <div className="bg-white rounded-xl p-4 md:p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-teal-100">
    <div className="h-12 w-12 md:h-14 md:w-14 rounded-full bg-gradient-to-br from-teal-500 to-teal-600 flex items-center justify-center mb-4">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-clock h-6 w-6 md:h-7 md:w-7 text-white"
      >
        <circle cx={12} cy={12} r={10} />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    </div>
    <h3 className="font-bold text-slate-900 text-base md:text-lg mb-2">
      24/7 Support
    </h3>
    <p className="text-sm text-slate-600 leading-relaxed">
      Round-the-clock assistance during your journey for a worry-free experience
    </p>
  </div>
  <div className="bg-white rounded-xl p-4 md:p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-teal-100">
    <div className="h-12 w-12 md:h-14 md:w-14 rounded-full bg-gradient-to-br from-teal-500 to-teal-600 flex items-center justify-center mb-4">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-compass h-6 w-6 md:h-7 md:w-7 text-white"
      >
        <circle cx={12} cy={12} r={10} />
        <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
      </svg>
    </div>
    <h3 className="font-bold text-slate-900 text-base md:text-lg mb-2">
      Flexible Customization
    </h3>
    <p className="text-sm text-slate-600 leading-relaxed">
      Modify your itinerary anytime to match your travel style and budget
    </p>
  </div>
</div>

                </div>
              </section>

              {/* Testimonials */}
              <section className="mt-12 md:mt-16">
                <div className="text-center mb-8 md:mb-10">
                  <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-900 mb-3">
                    What Travelers Say
                  </h2>
                  <p className="text-sm md:text-base text-slate-600">
                    Real experiences from our happy travelers
                  </p>
                </div>
                <div className="grid md:grid-cols-3 gap-4 md:gap-6">
                <div className="bg-white rounded-2xl p-5 md:p-6 shadow-lg hover:shadow-xl transition-shadow border-t-4 border-yellow-400">
                  <div className="flex mb-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                  </div>
                  <p className="text-sm md:text-base text-slate-700 leading-relaxed mb-4 italic">
                    "Amazing experience! The itinerary was perfectly planned and our guide was
                    exceptional. Connecting Traveller took care of every detail."
                  </p>
                  <div className="flex items-center gap-3 pt-3 border-t border-slate-100">
                    <div className="h-10 w-10 rounded-full bg-gradient-to-br from-teal-400 to-cyan-400 flex items-center justify-center">
                      <span className="text-white font-bold text-sm">RF</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 text-sm">
                        Rajesh &amp; Family
                      </h4>
                      <p className="text-xs text-slate-500">Dec 2025</p>
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-2xl p-5 md:p-6 shadow-lg hover:shadow-xl transition-shadow border-t-4 border-teal-400">
                  <div className="flex mb-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                  </div>
                  <p className="text-sm md:text-base text-slate-700 leading-relaxed mb-4 italic">
                    "Best decision ever! The customization options were endless and the team
                    was very responsive. Every destination was breathtaking."
                  </p>
                  <div className="flex items-center gap-3 pt-3 border-t border-slate-100">
                    <div className="h-10 w-10 rounded-full bg-gradient-to-br from-emerald-400 to-teal-400 flex items-center justify-center">
                      <span className="text-white font-bold text-sm">PS</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 text-sm">Priya Sharma</h4>
                      <p className="text-xs text-slate-500">Nov 2025</p>
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-2xl p-5 md:p-6 shadow-lg hover:shadow-xl transition-shadow border-t-4 border-cyan-400">
                  <div className="flex mb-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                  </div>
                  <p className="text-sm md:text-base text-slate-700 leading-relaxed mb-4 italic">
                    "Perfect honeymoon trip! Everything was arranged beautifully. The hotels
                    were amazing and the activities were well-timed. Thank you!"
                  </p>
                  <div className="flex items-center gap-3 pt-3 border-t border-slate-100">
                    <div className="h-10 w-10 rounded-full bg-gradient-to-br from-cyan-400 to-blue-400 flex items-center justify-center">
                      <span className="text-white font-bold text-sm">AN</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 text-sm">Amit &amp; Neha</h4>
                      <p className="text-xs text-slate-500">Oct 2025</p>
                    </div>
                  </div>
                </div>
              </div>

              </section>

             
            <CustomizedTripsDtlsmillerlist />


              {/* FAQ Section */}
              <section id="faqs" className="scroll-mt-28 mt-12 md:mt-16 -mx-4 md:-mx-6 lg:-mx-8 px-4 md:px-6 lg:px-8 py-8 md:py-12 bg-gradient-to-br from-slate-50 to-slate-100">
                <div className="max-w-4xl mx-auto">
                  <div className="text-center mb-8 md:mb-10">
                    <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-900 mb-3">
                      Frequently Asked Questions
                    </h2>
                    <p className="text-sm md:text-base text-slate-600">
                      Everything you need to know about booking with us
                    </p>
                  </div>
                  <div className="space-y-3 md:space-y-4">
                    {/* FAQ Item 1 */}
                    <div className="bg-white rounded-xl p-4 md:p-6 shadow-md hover:shadow-lg transition-shadow">
                      <div className="flex items-start gap-3">
                        <div className="flex-shrink-0 mt-1">
                          <div className="h-6 w-6 rounded-full bg-teal-100 flex items-center justify-center">
                            <span className="text-teal-600 font-bold text-sm">Q</span>
                          </div>
                        </div>
                        <div className="flex-1">
                          <h3 className="font-bold text-slate-900 text-base md:text-lg mb-2">
                            Can I customize the itinerary?
                          </h3>
                          <p className="text-sm md:text-base text-slate-600 leading-relaxed">
                            All our trips are fully customizable. You can modify destinations,
                            activities, accommodation preferences, and duration based on your
                            requirements and budget.
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* FAQ Item 2 */}
                    <div className="bg-white rounded-xl p-4 md:p-6 shadow-md hover:shadow-lg transition-shadow">
                      <div className="flex items-start gap-3">
                        <div className="flex-shrink-0 mt-1">
                          <div className="h-6 w-6 rounded-full bg-teal-100 flex items-center justify-center">
                            <span className="text-teal-600 font-bold text-sm">Q</span>
                          </div>
                        </div>
                        <div className="flex-1">
                          <h3 className="font-bold text-slate-900 text-base md:text-lg mb-2">
                            What is the booking process?
                          </h3>
                          <p className="text-sm md:text-base text-slate-600 leading-relaxed">
                            Simply send us an enquiry with your preferred dates and
                            requirements. Our travel experts will connect with you to
                            understand your needs and create a personalized itinerary with a
                            detailed quote.
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* FAQ Item 3 */}
                    <div className="bg-white rounded-xl p-4 md:p-6 shadow-md hover:shadow-lg transition-shadow">
                      <div className="flex items-start gap-3">
                        <div className="flex-shrink-0 mt-1">
                          <div className="h-6 w-6 rounded-full bg-teal-100 flex items-center justify-center">
                            <span className="text-teal-600 font-bold text-sm">Q</span>
                          </div>
                        </div>
                        <div className="flex-1">
                          <h3 className="font-bold text-slate-900 text-base md:text-lg mb-2">
                            What is your cancellation policy?
                          </h3>
                          <p className="text-sm md:text-base text-slate-600 leading-relaxed">
                            Our cancellation policy varies based on the package and timing.
                            Generally, cancellations made 30+ days prior receive a full
                            refund. Contact our team for specific terms for your booking.
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* FAQ Item 4 */}
                    <div className="bg-white rounded-xl p-4 md:p-6 shadow-md hover:shadow-lg transition-shadow">
                      <div className="flex items-start gap-3">
                        <div className="flex-shrink-0 mt-1">
                          <div className="h-6 w-6 rounded-full bg-teal-100 flex items-center justify-center">
                            <span className="text-teal-600 font-bold text-sm">Q</span>
                          </div>
                        </div>
                        <div className="flex-1">
                          <h3 className="font-bold text-slate-900 text-base md:text-lg mb-2">
                            Do you provide travel insurance?
                          </h3>
                          <p className="text-sm md:text-base text-slate-600 leading-relaxed">
                            We highly recommend travel insurance and can help you arrange
                            comprehensive coverage through our trusted partners. Insurance
                            typically covers medical emergencies, trip cancellations, and lost
                            baggage.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
             

             <CustomizedTripsDtlcoversdside />


          </div>

           

        </div>

        {/* Fixed Bottom Bar for Mobile */}
        <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 shadow-lg md:hidden">
          <div className="px-4 py-3">
            <div className="flex items-center justify-between gap-4">
              {/* Price Info */}
              <div>
                <div className="flex items-baseline gap-1.5">
                  <span className="text-xl font-bold text-primary">₹2,50,000</span>
                  <span className="text-xs text-slate-500">per person</span>
                </div>
                <p className="text-xs text-slate-600 mt-0.5">10 Days • 4 People</p>
              </div>
              {/* Send Enquiry Button */}
              <button className="inline-flex items-center justify-center whitespace-nowrap ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 py-2 bg-primary text-white hover:bg-primary/90 h-11 px-6 text-sm font-semibold rounded-full shadow-lg">
                {/* SVG icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-mail mr-2 h-4 w-4"
                >
                  <rect width={20} height={16} x={2} y={4} rx={2} />
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                </svg>
                Send Enquiry
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default SwissTripDetails;